import {get_user_directory} from '~/api/zero-api';
import useDataLoader from '~/hooks/shared/useDataLoader';


export default function useDirectoryLoader() {
    return useDataLoader(get_user_directory);
}